module.exports = __webpack_public_path__ + "static/media/SPB389_02.16ba459d.png";